import React from 'react';
import { createRoot } from 'react-dom/client';
import CoordinatorLogin from '../../components/Authentication/Coordinator/App';

$(document).ready(function () {
  if (!$(".coordinator-login-container").length) { return; }

  let pageConfigInit = JSON.parse(document.getElementById('AntiXssPageConfigInit').textContent);
  let module = angular.module("coordinatorLoginModule", ['CareEvWidgets', 'ngRoute', 'ngCookies', 'ResearchKitStudioModule']);

  module.constant("pageConfig", pageConfigInit);

  module.component('coordinatorLogin', {
    template: '<div></div>',
    controller: 'coordinatorLoginController',
    controllerAs: 'vm'
  });
  
  module.controller("coordinatorLoginController",
    ["$element", "$scope", "$cookies", function ($element, $scope, $cookies) {
      const $ctrl = this;
      let authenticationProps = null;
      const getAuthenticationProps = function () {
        const sessionCookieName = CareEv.ClientName + '.idsvr.session';
        const lastIdp = $cookies.get(CareEv.ClientName + 'LastIdentityProvider');
        const newProps = {
          cookies: $cookies,
          lastSessionCookie: $cookies.get(sessionCookieName),
          sessionCookieName,
          lastIdpLink: pageConfigInit.LastIdpLink?.Id === lastIdp ? pageConfigInit.LastIdpLink : null,
          signInId: pageConfigInit.SignInID,
          redirectUrl: pageConfigInit.RedirectUrl,
          hasMfaConfig: !!pageConfigInit.MfaConfig,
          allowSnooze2FA: pageConfigInit.MfaConfig?.AllowSnooze,
          totpKey: pageConfigInit.MfaConfig?.TotpKey,
          totpQrCodeUri: pageConfigInit.MfaConfig?.TotpQrCodeUri,
          totpAllowRememberMe: pageConfigInit.MfaConfig?.AllowRememberMe,
          totpRememberMeHours: pageConfigInit.MfaConfig?.RememberMeHours,
          passkeyServerBaseUrl: pageConfigInit.MfaConfig?.PasskeyServerBaseUrl,
          isTotpEnabled: pageConfigInit.MfaConfig?.IsTotpEnabled,
          hasRecoveryCodes: pageConfigInit.MfaConfig?.HasRecoveryCodes,
        }
        
        if (!angular.equals(authenticationProps, newProps)) {
          authenticationProps = newProps;
        }

        return authenticationProps;
      }

      function renderComponent() {
        $ctrl.root.render(
          <CoordinatorLogin {...getAuthenticationProps()} />
        );
      }

      $ctrl.$onInit = () => {
        $ctrl.root = createRoot($element[0]);
        renderComponent();
        $scope.$watch('$ctrl.props', function () {
          renderComponent();
        }, true);
      }

      $ctrl.$onDestroy = () => $ctrl.root.unmount();
    }])

  angular.bootstrap($(".coordinator-login-container"), ["coordinatorLoginModule"]);
});